<template>
  <DialogFrom 
    width="890px" 
    :title="title" 
    :OKASCAN="false" 
    :dialogVisible="visible" 
    @cancel="close" 
    @dialogOK="close"
  >
    <VideoPlayer 
      v-if="visible" 
      ref="videoPlayer" 
      :srcVideo="videoUrl"
    >
    </VideoPlayer>
  </DialogFrom>
</template>

<script>
import DialogFrom from '@/components/dialog-from.vue'
import VideoPlayer from '@/components/videoPlayer.vue'

export default {
  name: 'VideoDialog',
  components: {
    DialogFrom,
    VideoPlayer
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '视频播放'
    },
    videoUrl: {
      type: String,
      default: ''
    }
  },
  watch: {
    visible(val) {
      if (!val) {
        // 关闭时确保停止播放
        // VideoPlayer 组件内部可能需要优化，但 v-if="visible" 会销毁组件，所以自动停止
      }
    }
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
</style>
